export const formIdRoutes = {
  single: 'create',
  subscription: 'create-subscription',
};
